import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import { useState } from "react";

export default function AddCorrectionDialog({
  openCorrectionDialog,
  setOpenCorrectionDialog,
  appEntry,
  setAppEntry,
}) {
  const [reason, setReason] = useState("");

  const submitForCorrection = () => {
    AppEntryRepository.submitForCorrection(appEntry?.id, reason)
      .then((res) => {
        setOpenCorrectionDialog(false);
        setAppEntry(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Dialog
      open={openCorrectionDialog}
      onClose={() => {
        setOpenCorrectionDialog(false);
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          display: "flex",
          flexDirection: "column",
        },
      }}
      style={{ zIndex: 1300 }}
    >
      <DialogTitle>Причина за корекција</DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <TextField
            fullWidth
            placeholder="Причина"
            autoComplete="off"
            value={reason || ""}
            onChange={(e) => setReason(e.target.value)}
            multiline
            rows={4}
          />
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: "10px 25px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenCorrectionDialog(false);
          }}
          color="primary"
          size="small"
          style={{ width: "120px" }}
        >
          <Typography>Откажи</Typography>
        </Button>
        <Button
          variant="contained"
          colors="primary"
          size="large"
          onClick={() => {
            submitForCorrection();
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 80,
            }}
          >
            <Typography>Испрати на корекција</Typography>
          </Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
